import React, { useRef, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon, ZoomInIcon } from "lucide-react";
import { samplePages } from "../data/offer";
import { SectionHeading } from "./SectionHeading";
import { SampleLightbox } from "./SampleLightbox";
export function SamplesSection() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const scroll = (direction: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    track.scrollBy({
      left: direction * track.clientWidth * 0.8,
      behavior: "smooth"
    });
  };
  return <section className="bg-night py-16 text-white md:py-24" data-id="element-243" data-mp="1bce21h97bc7v">
      <div className="wrap" data-id="element-244" data-mp="16gf71atdavyh">
        <SectionHeading tone="dark" eyebrow="Mirá por dentro" title={<>
              Así se ven <span className="text-gold" data-id="element-246" data-mp="3870fkmtwz237">las páginas</span>
            </>} intro="Una selección de páginas interiores del libro. Tocá cualquiera para leerla en grande." data-id="element-245" data-mp="16daxrz11pa0y" />

        <div className="relative mt-12" data-id="element-247" data-mp="1lcpx469erqd9">
          <div ref={trackRef} className="no-scrollbar -mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-2 md:mx-0 md:px-0" aria-label="Muestras del material" data-id="element-248" data-mp="1ldso0e6qdst6">
            {samplePages.map((page, index) => <figure key={page.src} className="w-[72%] shrink-0 snap-center sm:w-[42%] lg:w-[calc((100%-64px)/5)]" data-id="element-249" data-mp="202f26ckmgeit" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(index)} aria-label={`Ampliar: ${page.caption}`} className="group relative block w-full overflow-hidden rounded-xl border border-white/10 bg-night-card" data-id="element-250" data-mp="24zxdg9m435tz">
                  <img src={page.src} alt={page.alt} loading="lazy" className="block aspect-[9/16] w-full object-cover object-top transition-transform duration-200 ease-out group-hover:scale-[1.02]" data-id="element-251" data-mp="epucjw45hnld" />
                  <span className="absolute bottom-3 right-3 flex h-9 w-9 items-center justify-center rounded-full bg-night/80 text-gold" data-id="element-252" data-mp="1i0rozylp9vip">
                    <ZoomInIcon className="h-4 w-4" aria-hidden="true" data-id="element-253" data-mp="1vwv6crbh69dr" />
                  </span>
                </button>
                <figcaption className="px-1 pt-3 text-sm text-haze" data-id="element-254" data-mp="25x5kce5c3ktz">{page.caption}</figcaption>
              </figure>)}
          </div>
          <div className="mt-6 flex justify-center gap-3 lg:hidden" data-id="element-255" data-mp="20xsvxoyte5pa">
            <button type="button" onClick={() => scroll(-1)} aria-label="Muestra anterior" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-colors duration-150 ease-out hover:bg-gold/10" data-id="element-256" data-mp="2epz34ljzp2cl">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-257" data-mp="2jq4vk3y32svq" />
            </button>
            <button type="button" onClick={() => scroll(1)} aria-label="Muestra siguiente" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-colors duration-150 ease-out hover:bg-gold/10" data-id="element-258" data-mp="33bn6ztrz4p06">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-259" data-mp="2y9xzup7vgvhd" />
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-260" data-mp="2pauc37xrfrwj">
        {openIndex !== null && <SampleLightbox pages={samplePages} index={openIndex} onClose={() => setOpenIndex(null)} onChange={setOpenIndex} data-id="element-261" data-mp="2pcdub42z8d0y" />}
      </AnimatePresence>
    </section>;
}